import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { changeBodyAttributeLeftbarMode } from "../helpers/utility/layout";
import { useToggle } from "../hooks";
import { useAppSelector } from "../redux/hooks";
import { RootState } from "../redux/store";
import LeftSidebar from "./LeftSidebar";
import MainSection from "./Nav/MainSection";
import Topbar from "./Topbar/Topbar";
import { useGetMenu } from "constants/menu";

type LayoutProps = {
	children: any;
};

export const MOBILE_WIDTH_THRESHOLD = 768;

const Layout = ({ children }: LayoutProps) => {
	const [isMenuOpened, toggleMenu] = useToggle();
	const isOpen = useAppSelector((state: RootState) => state.menuToggle.isSideMenuOpen);
	const user = useAppSelector((state: RootState) => state.logedinUser);
	const permissions = useAppSelector((state: RootState) => state.permissions);
	const global = useAppSelector((state: RootState) => state.global);
	const [menuItems, setMenuItems] = useState<any>();

	useEffect(() => {
		changeBodyAttributeLeftbarMode(isOpen);
	}, [isOpen]);

	const openMenu = () => {
		toggleMenu();
		if (document.body) {
			if (isMenuOpened) {
				document.body.classList.remove("sidebar-enable");
			} else {
				document.body.classList.add("sidebar-enable");
			}
		}
	};

	const menuFetcher = useGetMenu();

	useEffect(() => {
		if (user.permissions) {
			setMenuItems(menuFetcher(true, { ...user.permissions }))
		} else {
			setMenuItems(menuFetcher(true));
		}
	}, [user.permissions, global.numStockConflicts, global.featureFlags]);

	return (
		<>
			<div className="wrapper">
				{/* <SideNav/> */}
				<LeftSidebar isCondensed={true} isLight={false} hideUserProfile={true} menuItems={menuItems} toggleMenu={toggleMenu}/>
				<div className="content-page">
					<div className="content">
						{/* <TopNav/> */}
						<Topbar openLeftMenuCallBack={openMenu} pharmacyGroupMenu={true} />
						<Container fluid>
							<MainSection children={children}  />
						</Container>
					</div>
				</div>
			</div>
			{/* <RightSidebar /> */}
		</>
	);
}
export default Layout;